





















































import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { ITableScriptExecuteBehavior, IScriptExecuteParameter, ScriptExecuteTimingKinds } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { IExternalScriptSpecification } from "../../../../../formatEditor/domain/editableFormat";

@Component
export default class TableScriptExecuteBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITableScriptExecuteBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITableScriptExecuteBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get timing(): boolean {
    return this.readPropertyOrDefault(s => s.timing === ScriptExecuteTimingKinds.DocumentEditBegun, false);
  }

  set timing(value: boolean) {
    this.writePropertyWhenValid(s => s.timing = value ? ScriptExecuteTimingKinds.DocumentEditBegun : ScriptExecuteTimingKinds.Clicked);
  }

  get scriptPath(): string {
    return this.readPropertyOrDefault(s => s.scriptPath, "");
  }

  get separator(): string {
    return this.readPropertyOrDefault(s => s.separator, "");
  }

  get parameters(): IScriptExecuteParameter[] {
    return this.readPropertyOrDefault(s => s.parameters, []);
  }

  get selectableExternalScripts(): IExternalScriptSpecification[] {
    return this.commonComponents.readPropertyOrDefault(s => s.getSpecification().externalScripts, []);
  }

  get csvFilePathFormat(): string {
    return this.readPropertyOrDefault(s => s.csvFilePathFormat, "");
  }

  set csvFilePathFormat(value: string) {
    this.writePropertyWhenValid(s => s.csvFilePathFormat = value);
  }

  get valuesXmlPathFormat(): string {
    return this.readPropertyOrDefault(s => s.valuesXmlPathFormat, "");
  }

  set valuesXmlPathFormat(value: string) {
    this.writePropertyWhenValid(s => s.valuesXmlPathFormat = value);
  }

  get previousValuesCsvFilePathFormat(): string {
    return this.readPropertyOrDefault(s => s.previousValuesCsvFilePathFormat, "");
  }

  set previousValuesCsvFilePathFormat(value: string) {
    this.writePropertyWhenValid(s => s.previousValuesCsvFilePathFormat = value);
  }

  get inputValuesCsvFilePathFormat(): string {
    return this.readPropertyOrDefault(s => s.inputValuesCsvFilePathFormat, "");
  }

  set inputValuesCsvFilePathFormat(value: string) {
    this.writePropertyWhenValid(s => s.inputValuesCsvFilePathFormat = value);
  }

  async showScriptPathEditDialog() {
    const dialog = this.commonComponents.getDialogs().getScriptPathEditDialog();
    const parameter = await dialog.show({
      scriptPath: this.scriptPath,
      separator: this.separator,
      parameters: this.parameters,
    }, this.selectableExternalScripts);
    if (!parameter) { return; }
    this.writePropertyWhenValid(s => {
      s.scriptPath = parameter.scriptPath;
      s.separator = parameter.separator;
      s.parameters = parameter.parameters;
    });
  }

  async showCsvFilePathFormatEditDialog() {
    const dialog = this.commonComponents.getDialogs().getFilePathEditDialog();
    const filePath = await dialog.show(this.csvFilePathFormat);
    if (!filePath) { return; }
    this.csvFilePathFormat = filePath;
  }

  async showPreviousValuesCsvFilePathFormatEditDialog() {
    const dialog = this.commonComponents.getDialogs().getFilePathEditDialog();
    const filePath = await dialog.show(this.previousValuesCsvFilePathFormat);
    if (!filePath) { return; }
    this.previousValuesCsvFilePathFormat = filePath;
  }

  async showInputValuesCsvFilePathFormatEditDialog() {
    const dialog = this.commonComponents.getDialogs().getFilePathEditDialog();
    const filePath = await dialog.show(this.inputValuesCsvFilePathFormat);
    if (!filePath) { return; }
    this.inputValuesCsvFilePathFormat = filePath;
  }

  async showValuesXmlPathFormatEditDialog() {
    const dialog = this.commonComponents.getDialogs().getFilePathEditDialog();
    const filePath = await dialog.show(this.valuesXmlPathFormat);
    if (!filePath) { return; }
    this.valuesXmlPathFormat = filePath;
  }
}
